import * as types from './types';
import { createReducer } from '../../utils/reducerHelper';
import initialState from './initial-state';

const reducersMap = {
   [types.GET_STORE_DATA_START]: (state) => {
      return {
         ...state,
         isLoading: true,
      };
   },
   [types.GET_STORE_DATA_COMPLETED]: (state, action) => {
      return {
         ...state,
         settings: action.payload.settings || {},
         products: action.payload.products || [],
         collections: action.payload.collections || [],
         owner: action.payload.owner || null,
         isLoading: false,
      };
   },
   [types.GET_STORE_DATA_FAILED]: (state) => {
      return {
         ...state,
         isLoading: false,
      };
   },
   [types.UPDATE_STORE_SETTINGS_START]: (state) => {
      return {
         ...state,
         isSaving: true,
      };
   },
   [types.UPDATE_STORE_SETTINGS_COMPLETED]: (state, action) => {
      return {
         ...state,
         settings: action.payload || state.settings,
         isSaving: false,
      };
   },
   [types.UPDATE_STORE_SETTINGS_FAILED]: (state) => {
      return {
         ...state,
         isSaving: false,
      };
   },
   [types.SET_SELECTED_PRODUCT]: (state, action) => {
      return {
         ...state,
         selectedProduct: action.payload,
      };
   },
   [types.CLEAR_SELECTED_PRODUCT]: (state) => {
      return {
         ...state,
         selectedProduct: null,
      };
   },
};

export default createReducer(initialState)(reducersMap);
